import { UserManager } from 'oidc-client-ts';
import { OidcUserManager } from '@/models/OidcUserManager.model';

export class OidcLogin {

  public static getUserManager(user: OidcUserManager): UserManager {

    return new UserManager({
      authority: user.authority,
      client_id: user.clientId,
      redirect_uri: window.location.origin + user.redirectUri,
      scope: user.scope,
      client_secret: user.clientSecret,
    });

  }

}
